"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTypes = void 0;
var ActionTypes;
(function (ActionTypes) {
    ActionTypes[ActionTypes["SET_MESSAGES"] = 0] = "SET_MESSAGES";
    ActionTypes[ActionTypes["SET_ACTIVE_MENU"] = 1] = "SET_ACTIVE_MENU";
    ActionTypes[ActionTypes["SET_SEARCH_OPEN"] = 2] = "SET_SEARCH_OPEN";
    ActionTypes[ActionTypes["SET_MOBILE_OPEN"] = 3] = "SET_MOBILE_OPEN";
    ActionTypes[ActionTypes["SET_INNER_MOBILE_ACTIVE_MENU"] = 4] = "SET_INNER_MOBILE_ACTIVE_MENU";
    ActionTypes[ActionTypes["SET_MOBILE_LOCALE_OPEN"] = 5] = "SET_MOBILE_LOCALE_OPEN";
    ActionTypes[ActionTypes["SET_MOBILE_SIGNIN_OPEN"] = 6] = "SET_MOBILE_SIGNIN_OPEN";
})(ActionTypes = exports.ActionTypes || (exports.ActionTypes = {}));
//# sourceMappingURL=navActions.js.map